import type {ValidationMessageTemplate} from "@vee-validate/i18n"

export default {
    messages: {
        verify_password: "Das Passwort ist zu schwach. Bitte wähle ein stärkeres Passwort",
        confirm_password: "Das Passwort stimmt nicht überein",
        verify_url: "URL ist ungültig",
        validation_pending: "Wird geprüft...",
        editor_content_required: "{field} ist ein Pflichtfeld",
        puzzle_unsolved: "Du hast dieses Rätsel noch nicht gelöst...",
        juleica_card_number_doesnt_match_with_contact: "{_value_} ist eine gültige Kartennummer, passt aber nicht zu den Daten des Kontakts.",
        juleica_invalid: "{_value_} ist keine gültige Juleica-Kartennummer oder ist bereits abgelaufen.",
        iban_invalid: "Ihre IBAN ist ungültig. Bitte überprüfen Sie Ihre eingebene IBAN.",
        phone_invalid: "Das Format der Telefonnummer ist nicht ungültig.",
        includes: "Die Eingabe muss '0:{text}' enthalten.",
        valid_date: "Der eingegebene Wert ist kein gültiges Datum. Bestenfalls sollte das Format DD.MM.YYYY verwendet werden.",
        date_is_after: "Das eingegebene Datum ist nicht gültig.",
        date_is_before: "Das eingegebene Datum ist nicht gültig.",
        is_regex: "Eingabe ist kein gültiger Regulärer Ausdruck.",
        pending: "Wird geprüft...",
        valid_domain: "Die Domain ist ungültig. Bitte überprüfe die Eingabe.",
        deeply_nested: "Ungültiger Zustand! Gruppenfragen dürfen nicht verschachtelt werden.",
    }
} as {
    messages: Record<string, ValidationMessageTemplate>
}
